import PrelimApi from './PrelimApi';

export default PrelimApi;
